export default __webpack_public_path__ + "static/media/user_blue.03a8dd7a.svg";